module.exports = __webpack_public_path__ + "img/company.c1e44ff6.png";